import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
const links = [
  { to: "/", label: "Home" },
  { to: "/destinations", label: "Destinations" },
  { to: "/programs", label: "Programs" },
  { to: "/packages", label: "Packages" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/apply", label: "Apply Now", highlight: true },
  { to: "/partner", label: "Partner With Us" },
  { to: "/about", label: "About" },
  { to: "/faqs", label: "FAQs" },
  { to: "/contact", label: "Contact" },
];

const APPLY_ACTIVE = "bg-orange-500 text-white shadow-md shadow-orange-500/30";
const APPLY_IDLE = "bg-orange-500 text-white hover:bg-orange-600 shadow-md shadow-orange-500/30";
const DEFAULT_ACTIVE = "bg-slate-900 text-white";
const DEFAULT_IDLE = "text-slate-600 hover:text-slate-900 hover:bg-slate-100";

function desktopClass(link, isActive) {
  if (link.highlight) {
    return `px-3 py-2 rounded-full text-sm font-semibold transition-colors ${isActive ? APPLY_ACTIVE : APPLY_IDLE}`;
  }
  return `px-3 py-2 rounded-full text-sm font-medium transition-colors ${isActive ? DEFAULT_ACTIVE : DEFAULT_IDLE}`;
}

function mobileClass(link, isActive) {
  if (link.highlight) {
    return `px-3 py-2 rounded-lg text-sm font-semibold ${isActive ? "bg-orange-600 text-white" : "bg-orange-500 text-white"}`;
  }
  return `px-3 py-2 rounded-lg text-sm ${isActive ? "bg-slate-900 text-white" : "text-slate-700 hover:bg-slate-50"}`;
}

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 glass border-b border-slate-100" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center group" data-testid="nav-logo">
          <img
            src="/brand/logo-round.png"
            alt="StudyTrip Global — Learn. Travel. Grow."
            className="h-11 md:h-12 w-auto"
            loading="eager"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) => desktopClass(l, isActive)}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 rounded-lg hover:bg-slate-100 transition-colors"
            data-testid="nav-mobile-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-100 bg-white" data-testid="nav-mobile-menu">
          <div className="px-5 py-3 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) => mobileClass(l, isActive)}
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
